import React, { Component } from 'react';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Card,
	CardContent,
	Typography,
	Chip
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
} from '@material-ui/icons';

import { MyPATDialog, MyPATIconButton, MyPATTextField, SearchField } from '../../common';

import { UserBody } from '../types/UsersBody';
import { UserRoleBody } from '../types/UserRolesBody';
import { UserGroupsBody } from '../types/UserGroupsBody';
import { newUser, updateUser, deleteUser } from '../actions/usersActions';
import ACLService from '../../acl/services/aclService';
import { usersList } from '../actions/usersActions';
import { UserRoleList } from '../actions/userRoleAction';
import { userGroupsList } from '../actions/userGroupsActions';


const styles = (theme: Theme) => createStyles({
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	width40: {
		width: "30px"
	},
	mb2x: {
		marginBottom: theme.spacing.unit * 2,
	},
	cardRoot: {
		overflow: "visible"
	},
	cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
		overflow: "visible"
	},
	dialogCloseContainer: {
		textAlign: 'right',
	},
	uploadImg: {
		display: "inline-block",
		position: "relative",
		paddingTop: theme.spacing.unit,
		'& > p': {
			color: theme.palette.primary.main,
			cursor: "pointer"
		}
	},
	fileUpload: {
		top: 0,
		left: 0,
		width: "100%",
		cursor: "pointer",
		height: "100%",
		margin: 0,
		opacity: 0,
		padding: 0,
		position: "absolute"
	},
	suggestContainer: {
		position: 'relative',
	},
	suggestList: {
		position: 'absolute',
		width: '100%',
		height: 'auto',
		top: '34px',
		left: '0',
		padding: 0,
		marginTop: 0,
		zIndex: 1,
		listStyleType: 'none',
		backgroundColor: theme.palette.common.white,
		boxShadow: theme.shadows[1],
		borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
		'& li': {
			...theme.typography.body2,
			fontWeight: theme.typography.fontWeightRegular,
			display: 'block',
			cursor: 'pointer',
			padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
			'&.selected': {
				backgroundColor: theme.palette.grey[200],
			}
		}
	},
	searchUserGroupRoot: {
		border: `1px solid ${theme.palette.grey[300]}`,
		borderRadius: theme.shape.borderRadius,
		padding: `0 ${theme.spacing.unit}px`,
	},
	selectedBreadCrumb: {
		listStyle: 'none',
		alignItems: 'center',
		paddingLeft: 0,
		margin: 0,
		marginBottom: theme.spacing.unit,
		'& li': {
			...theme.typography.body2,
			marginRight: theme.spacing.unit / 2
		},
	},
	chipItem: {
		display: "inline-block",
		
	},
	chipWrap: {
		padding: `0 ${theme.spacing.unit}px`,
		'& > div': {
			marginRight: theme.spacing.unit / 2,
			marginBottom: theme.spacing.unit / 2,
			'& > span': {
				fontSize: "0.7rem"
			}
		}
	},
	fwNormal: {
		fontWeight: theme.typography.fontWeightRegular
	}
});

interface AddUserDialogProps extends WithStyles<typeof styles> {
	dialogOpen: boolean,
	dialogCloseHandler: Function,
	users: UserBody[],
	userGroups: UserGroupsBody[],
	rolesList: UserRoleBody[],
	isDone: () => void,
	userProfile: UserBody,
	usersList: () => void,
	UserRoleList: () => void,
	userGroupsList: () => void,
}

interface AddUserDialogState {
	suggestedUserGroup: any,
	suggestedReviewers: any,
	suggestedRoles: any,
	showSuggestedUserGroup: boolean,
	showSuggestedReviewerGroup: boolean,
	showSuggestedRoles: boolean,
	formData: any,
	errForm: any,
	selectedUserGroup: any[],
	selectedReviewers: any[],
	selectedRoles: any[],
	isForEdit: boolean,
	removedSelectedGroupId: any[]
}

class AddUserDialog extends Component<AddUserDialogProps, AddUserDialogState> {
	loadListTimer: any = 0;

	constructor(props: AddUserDialogProps) {
		super(props);
		this.state = {
			suggestedUserGroup: [],
			suggestedReviewers: [],
			suggestedRoles: [],
			showSuggestedUserGroup: false,
			showSuggestedReviewerGroup: false,
			showSuggestedRoles: false,
			formData: { name: "", userName: "", profileImg: { profileName: "", profilePic: {} } },
			errForm: { name: "", userName: "" },
			selectedUserGroup: [],
			selectedReviewers: [],
			selectedRoles: [],
			isForEdit: false,
			removedSelectedGroupId: []
		};

		this.handleChangeEvent = this.handleChangeEvent.bind(this);
		this.handleDialogSave = this.handleDialogSave.bind(this);
		this.searchUserGroupSuggestion = this.searchUserGroupSuggestion.bind(this);
		this.chooseUserGroup = this.chooseUserGroup.bind(this);
		this.searchReviewerGroupSuggestion = this.searchReviewerGroupSuggestion.bind(this);
		this.searchRolesSuggestion = this.searchRolesSuggestion.bind(this);
		this.closeDialog = this.closeDialog.bind(this);
	}



	componentWillReceiveProps() {
		setTimeout(this.isForEdit.bind(this), 600);
		//Will load data for others module i.e dashboard

		if (this.loadListTimer == 0) {
			this.loadListTimer = setTimeout(() => {
				this.loadList.bind(this);
				this.loadListTimer = 0;
			}, 1000);
		}
	}

	componentWillUnmount() {
		clearTimeout(this.loadListTimer)
	}

	loadList() {
		let { userGroups, users, rolesList } = this.props;

		if (userGroups.length == 0) {
			this.props.userGroupsList();
		}

		if (users.length == 0) {
			this.props.usersList();
		}

		if (rolesList.length == 0) {
			this.props.UserRoleList();
		}
	}

	isForEdit() {
		let { selectedUserGroup, selectedReviewers, formData, isForEdit } = this.state;
		let { userProfile } = this.props;
		if (userProfile && userProfile._id) {
			formData["name"] = userProfile.fullName;
			formData["userName"] = userProfile.userName ? userProfile.userName : userProfile.email;
			formData["profileImg"]["profileName"] = userProfile.profileImage ? userProfile.profileImage.split(/(\\|\/)/g).pop() : "";
			selectedUserGroup = userProfile.groupsId;
			isForEdit = true;
			this.setState({ formData, selectedUserGroup, isForEdit })
		}
	}

	handleDialogSave = () => {
		let { formData, errForm, selectedUserGroup, selectedReviewers, selectedRoles, isForEdit, removedSelectedGroupId } = this.state;
		let { userProfile } = this.props;

		if (formData.name != "" && (formData.userName != "" && !this.validateUserName(formData.userName))) {
			let formD = new FormData();
			formD.append('userName', formData.userName);


			if (formData.profileImg.profilePic) {
				formD.append('file', formData.profileImg.profilePic);
			}

			formD.append('name', formData.name);
			formD.append('groupsId', JSON.stringify(selectedUserGroup.map((o: any) => o._id)));
			formD.append('reviewer', JSON.stringify(selectedReviewers.map((o: any) => o._id)));

			if (!isForEdit) {
				newUser(formD)
					.then((res: any) => {
						if (res && res == 200) {
							this.props.isDone();
						}
					})
			}
			else {
				formD.append('userId', userProfile._id);
				formD.append('removedSelectedGroupId', JSON.stringify(removedSelectedGroupId));
				updateUser(formD)
					.then((res: any) => {
						if (res) {
							this.props.isDone();
						}
					})
			}

		}
		else {
			errForm.name = formData.name == "" ? 'Required *' : errForm.name;
			errForm.userName = formData.userName == "" ? 'Required *' : errForm.userName;
			this.setState({ errForm });
			return false;
		}
	}


	handleRemoveUser(e: any) {
		let { userProfile } = this.props;
		if (userProfile._id) {
			let userName: any = userProfile.userName ? userProfile.userName : userProfile.email;
			deleteUser(userProfile)
				.then((resp) => {
					this.props.isDone();
				})
		}
	}


	handleChangeEvent = (e: any) => {
		let { formData, errForm } = this.state;
		let { name, value } = e.target;
		if (!value) {
			errForm[name] = 'Required *';
		}
		else {
			errForm[name] = '';
		}
		formData[name] = value;
		this.setState({ formData, errForm });
	}

	userNameValidation(e: any) {
		let { name, value } = e.target;
		this.validateUserName(value);
	}

	validateUserName(userName: any) {
		let { errForm } = this.state;
		let hasError = false;

		if (this.validateEmail(userName.trim()))
			errForm["userName"] = '';
		else {
			hasError = true;
			errForm["userName"] = 'Invalid Email';
		}
		this.setState({ errForm });
		return hasError;
	}

	validateEmail(email: string) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	searchUserGroupSuggestion(e: any) {
		let { userGroups } = this.props;
		let { suggestedUserGroup } = this.state;
		let { name, value } = e.target;
		suggestedUserGroup = [];
		userGroups.forEach((userGroup: any) => {
			if (value && userGroup && userGroup.name && userGroup.name.toLowerCase().search(value.toLowerCase()) != -1) {
				if (suggestedUserGroup.length < 5) {
					suggestedUserGroup.push(userGroup);
				} else {
					return false;
				}
			}
		});
		this.setState({ suggestedUserGroup });
	}

	chooseUserGroup(userGroup: any, isAdd: boolean) {
		let { selectedUserGroup, removedSelectedGroupId } = this.state;
		if (isAdd) {
			let isUserPresnt = _.find(selectedUserGroup, ['_id', userGroup._id]);
			if (!isUserPresnt)
				selectedUserGroup.push(userGroup);
		}
		else {
			removedSelectedGroupId.push(userGroup._id);
			selectedUserGroup = selectedUserGroup.filter(ob => ob._id != userGroup._id);
		}
		this.setState({ selectedUserGroup })
	}
	// showSuggestedReviewerGroup
	searchReviewerGroupSuggestion(e: any) {
		let { users } = this.props;
		let { suggestedReviewers } = this.state;
		let { name, value } = e.target;
		suggestedReviewers = [];
		users.forEach((user: any) => {
			if (value && user && user.fullName && user.fullName.toLowerCase().search(value.toLowerCase()) != -1) {
				if (suggestedReviewers.length < 5) {
					suggestedReviewers.push(user);
				} else {
					return false;
				}
			}
		});
		this.setState({ suggestedReviewers });
	}

	chooseReviewerGroup(user: any, isAdd: boolean) {
		let { selectedReviewers } = this.state;
		if (isAdd) {
			let isUserPresnt = _.find(selectedReviewers, ['_id', user._id]);
			if (!isUserPresnt)
				selectedReviewers.push(user);
		}
		else
			selectedReviewers = selectedReviewers.filter((ob: any) => ob._id != user._id);
		this.setState({ selectedReviewers })
	}

	searchRolesSuggestion(e: any) {
		let { rolesList } = this.props;
		let { suggestedRoles } = this.state;
		let { name, value } = e.target;
		suggestedRoles = [];
		rolesList.forEach((r: any) => {
			if (value && r && r.role && r.role.toLowerCase().search(value.toLowerCase()) != -1) {
				if (suggestedRoles.length < 5) {
					suggestedRoles.push(r);
				} else {
					return false;
				}
			}
		});
		this.setState({ suggestedRoles });
	}

	chooseRoles(role: any, isAdd: boolean) {
		let { selectedRoles } = this.state;
		if (isAdd) {
			let isUserPresnt = _.find(selectedRoles, ['_id', role._id]);
			if (!isUserPresnt)
				selectedRoles.push(role);
		}
		else
			selectedRoles = selectedRoles.filter(ob => ob._id != role._id);
		this.setState({ selectedRoles })
	}


	uploadImg(e: any) {
		let { value, files } = e.target;
		let { formData } = this.state;
		if (value && files && files.length > 0) {
			let a = value ? value.split(/(\\|\/)/g).pop() : "";
			formData.profileImg.profileName = a;
			formData.profileImg.profilePic = files[0];
			this.setState({ formData });
		}

	}


	closeDialog() {
		this.props.dialogCloseHandler();
	}

	render() {
		const {
			classes,
			dialogOpen,
			dialogCloseHandler,
		} = this.props;
		const {
			suggestedUserGroup,
			showSuggestedUserGroup,
			selectedUserGroup,
			suggestedReviewers,
			suggestedRoles,
			showSuggestedRoles,
			selectedRoles,
			formData,
			errForm,
			selectedReviewers,
			showSuggestedReviewerGroup,
			isForEdit
		} = this.state
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};


		const getUserGroup = () => (
			_.map(selectedUserGroup, (gr, i) => (
				<Chip
					label={gr.name}
					key={`${gr.id}_${i}`}
					onDelete={this.chooseUserGroup.bind(this, gr, false)}
				/>
			))

		)
		const getReviewerGroup = () => (
			_.map(selectedReviewers, (gr, i) => (
				<Chip
				    key={`${gr.id}_${i}`}
					label={gr.fullName}
					onDelete={this.chooseReviewerGroup.bind(this, gr, false)}
				/>
			))
		)



		return (
			<MyPATDialog
				dialogOpen={dialogOpen}
				otherDialogProps={otherDialogProps}
				onDialogSave={this.handleDialogSave.bind(this)}
				onDialogDelete={isForEdit ? this.handleRemoveUser.bind(this) : undefined}
				customDialogTitle={
					<Grid container justify="space-between" alignItems="center">
						<Grid item xs>
							<Typography variant="h6">
								{isForEdit ? 'Edit User' : 'Add User'}
							</Typography>
						</Grid>

						<Grid item xs="auto" className={classes.dialogCloseContainer}>
							<MyPATIconButton buttonVariant="flat" onClick={this.closeDialog}>
								<CloseIcon />
							</MyPATIconButton>
						</Grid>
					</Grid>
				}
			>
				<Card className={classes.cardRoot}>
					<CardContent className={classes.cardContentRoot}>
						<Grid container spacing={8} alignItems="center">
							<Grid item xs={12} className={classes.mb1x}>
								<Typography variant="body1" gutterBottom>Name</Typography>
								<MyPATTextField
									error={!_.isEmpty(errForm.name) ? true : false}
									errorText={errForm.name}
									inputId="name"
									name="name"
									placeholder="Enter User Name"
									value={formData.name || ''}
									onChange={this.handleChangeEvent.bind(this)}
									fullWidthControl
								/>
							</Grid>

							<Grid item xs={12} className={classes.mb1x}>
								<Typography variant="body1" gutterBottom>Profile Picture</Typography>
								<div className={classes.uploadImg}>
									<Typography inline variant="body2"> Upload Picture</Typography>
									<input type="file" accept="image/*" onChange={this.uploadImg.bind(this)} name="profileName" className={classes.fileUpload} />
									<Typography inline variant="caption">{formData.profileImg.profileName}</Typography>
								</div>
							</Grid>

							<Grid item xs={12} className={classes.mb1x}>
								<Typography variant="body1" gutterBottom>User Credential</Typography>
								<MyPATTextField
									fullWidthControl
									error={!_.isEmpty(errForm.userName) ? true : false}
									errorText={errForm.userName}
									inputId="userName"
									onBlur={this.userNameValidation.bind(this)}
									name="userName"
									autoComplete="new-password"
									autofill="off"
									placeholder="Enter User's email"
									value={formData.userName || ''}
									onChange={this.handleChangeEvent.bind(this)}
									disabled={isForEdit}
								/>
							</Grid>
							{/* {
								_.isEqual(isForEdit, false) &&
								<Grid item xs={6} className={classes.mb1x}>
									<Typography variant="body1" gutterBottom>Password</Typography>
									<MyPATTextField
										fullWidthControl
										onBlur={this.phoneNumberValidation.bind(this)}
										error={errForm.password != "" ? true : false}
										errorText={errForm.password}
										inputId="password"
										name="password"
										type="password"
										autoComplete="new-password"
										autofill="off"
										placeholder="Set Password"
										value={formData.password || ''}
										onChange={this.handleChangeEvent.bind(this)}
									/>
								</Grid>
							} */}


							<Grid item xs={12} className={classes.mb1x}>
								<Typography variant="body1" gutterBottom>User Group(s)</Typography>
								<div className={classes.chipWrap}>
									{getUserGroup()}
								</div>
								<div className={classes.suggestContainer}>
									<SearchField
										name="userGroup"
										id="userGroup"
										placeholder="Enter group name to add the user"
										className={classes.searchUserGroupRoot}
										onFocus={() => { this.setState({ showSuggestedUserGroup: true }) }}
										onBlur={() => { setTimeout(() => { this.setState({ showSuggestedUserGroup: false }) }, 500) }}
										onChange={this.searchUserGroupSuggestion}
										fullWidth
									/>
									{showSuggestedUserGroup && suggestedUserGroup.length > 0 && (
										<ul className={classes.suggestList}>
											{_.map(suggestedUserGroup, (sc, i: number) => (
												<li key={i}
													className={_.find(selectedUserGroup, ['_id', sc._id]) ? 'selected' : ''}
													onClick={this.chooseUserGroup.bind(this, sc, true)}
												>
													{sc.name}
												</li>
											))}
										</ul>
									)}
								</div>
							</Grid>

							{/* <Grid item xs={12} className={classes.mb1x}>
								<Typography variant="body1" gutterBottom>Select Reviewer</Typography>
								<div className={classes.chipWrap}>
									{getReviewerGroup()}
								</div>
								<div className={classes.suggestContainer}>
									<SearchField
										name="reviewerGroup"
										id="reviewerGroup"
										placeholder="Search Users"
										className={classes.searchUserGroupRoot}
										onFocus={() => { this.setState({ showSuggestedReviewerGroup: true }) }}
										onBlur={() => { setTimeout(() => { this.setState({ showSuggestedReviewerGroup: false }) }, 500) }}
										onChange={this.searchReviewerGroupSuggestion}
										fullWidth
									/>
									{showSuggestedReviewerGroup && suggestedReviewers.length > 0 && (
										<ul className={classes.suggestList}>
											{_.map(suggestedReviewers, (sc, i: number) => (
												<li key={i}
													className={_.find(selectedReviewers, ['_id', sc._id]) ? 'selected' : ''}
													onClick={this.chooseReviewerGroup.bind(this, sc, true)}
												>
													{sc.fullName}
												</li>
											))}
										</ul>
									)}
								</div>
							</Grid> */}

							{/* <Grid item xs={12}>
                                <div className={classes.suggestContainer}>
                                    <Typography variant="body2" className={classes.fwNormal}>Select Roles</Typography>
                                    <div className={classes.chipWrap}>
                                        {getRoles()}
                                    </div>
                                    <SearchField
                                        name="role"
                                        id="role"
                                        placeholder="Search Roles"
                                        className={classes.searchUserGroupRoot}
                                        onFocus={() => { this.setState({ showSuggestedRoles: true }) }}
                                        onBlur={() => { setTimeout(() => { this.setState({ showSuggestedRoles: false }) }, 500) }}
                                        onChange={this.searchRolesSuggestion}
                                        fullWidth
                                    />
                                    {
                                        showSuggestedRoles && suggestedRoles.length > 0 && (
                                            <ul className={classes.suggestList}>
                                                {
                                                    _.map(suggestedRoles, (sc, i: number) => (
                                                        <li key={i} className={classes.suggestItem}
                                                            onClick={this.chooseRoles.bind(this, sc, true)} >
                                                            <Typography variant="caption">{sc.role}</Typography>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        )
                                    }
                                </div>
                            </Grid> */}
						</Grid>
					</CardContent>
				</Card>
			</MyPATDialog>
		);
	}
}
const mapStateToProps = (state: any) => ({
	userGroups: _.get(state, 'userManagement.userGroups.list', []),
	users: _.get(state, 'userManagement.users.list', []),
	rolesList: _.get(state, 'userManagement.userRoleList.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	usersList,
	UserRoleList,
	userGroupsList,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddUserDialog));